import { defineStore } from 'pinia'
import { ref } from 'vue'

import type {
  OrganizationPerimetersFilters,
  OrganizationPerimetersFiltersStore,
} from '@/contexts/organization/Organization.interfaces'
import { getDefaultOrganizationPerimetersFilters } from '@/contexts/organization/Organization.helpers'

export const useOrganizationPerimetersFiltersStore = defineStore(
  'organization-perimeters-filters',
  () => {
    const organizationPerimetersFilters = ref<OrganizationPerimetersFiltersStore[]>([])

    const getOrganizationPerimetersFilters = (customerId: number): OrganizationPerimetersFilters => {
      return (
        organizationPerimetersFilters.value.find((storedFilters) => storedFilters.customerId === customerId)?.filters ??
        getDefaultOrganizationPerimetersFilters()
      )
    }

    const updateOrganizationPerimetersFilters = (customerId: number, filters: OrganizationPerimetersFilters): void => {
      const filterIndex = organizationPerimetersFilters.value.findIndex(
        (storedFilters) => storedFilters.customerId === customerId
      )

      if (filterIndex >= 0) {
        organizationPerimetersFilters.value.splice(filterIndex, 1, { customerId, filters })
        return
      }

      organizationPerimetersFilters.value.push({ customerId, filters })
    }

    const $reset = (): void => {
      organizationPerimetersFilters.value = []
    }

    return {
      organizationPerimetersFilters,
      getOrganizationPerimetersFilters,
      updateOrganizationPerimetersFilters,
      $reset,
    }
  },
  { persist: true }
)
